module.exports = __webpack_public_path__ + "static/img/member_temp.dd7492b0.png";